import { useMutation } from "react-query"
import api from "../client"
import { AuthLoginPayload, AuthLoginResponseData } from "../types/auth"

const postData = async (payload: AuthLoginPayload) => {
    const { data } = await api.post<AuthLoginResponseData>(
        "/auth",
        payload
    )
    return data
}

export const useAuthLogin = () => {
    return useMutation((payload: AuthLoginPayload) => {
        return postData(payload)
    })
}
